import { render, staticRenderFns } from "./RotateScreenMessage.vue?vue&type=template&id=e7d94c80"
var script = {}
import style0 from "./RotateScreenMessage.vue?vue&type=style&index=0&id=e7d94c80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports